/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundDto } from '../../models/backend-venture-fund-dto';
import { BackendVentureFundRequestDto } from '../../models/backend-venture-fund-request-dto';

export interface VentureFundsVentureFundsUpdate$FormData$Params {
  id: number;
  body: BackendVentureFundRequestDto;
}

export function ventureFundsVentureFundsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDto>;
    }),
  );
}

ventureFundsVentureFundsUpdate$FormData.PATH = '/api/venture_funds/venture-funds/{id}/';
